module.exports = __webpack_public_path__ + "static/9.1_ancient_america_geography-6210d5317c0a8d70232b60b0ef92a06d.pdf";